import { Model } from "@/models";

export default class ClientAgent extends Model {
  static type = "clientsAgents";

  name!: string;
  email!: string;
}
